const PLACEMENT_LABELS: Record<string, string> = {
  passenger_home_header: 'Top of passenger home screen',
  splash_takeover: 'Full screen when the app opens',
  commute_morning_takeover: 'Driver app, morning rush',
  commute_evening_takeover: 'Driver app, evening rush',
  festival_event_takeover: 'Festival/event full takeover',
  ride_complete_full: 'After ride completion modal',
  weather_alert_banner: 'Weather alert companion',
  map_pin_featured: 'Featured pin on passenger map',
  passenger_sheet_idle_carousel: 'Bottom sheet: Where To carousel',
  passenger_sheet_confirm_carousel: 'Bottom sheet: Confirm ride carousel',
  passenger_sheet_active_ride_carousel: 'Bottom sheet: Active ride carousel',
};

/** Plain-English name for an `ad_campaigns.placement` value. */
export function placementLabel(p: string): string {
  return PLACEMENT_LABELS[p] || p.replace(/_/g, ' ');
}
